import { combineReducers } from "@reduxjs/toolkit";
import schoolDistrictSlice from "./schoolDistrictSlice";

export const schoolDistrictReducer = combineReducers({
  schoolDistricts: schoolDistrictSlice,
});